import toast from "react-hot-toast";
import { ReactComponent as Check } from "../assets/icons/check-mark.svg";
import { ReactComponent as Cross } from "../assets/icons/x.svg";

export function ShowToast({
  message,
  type,
}: {
  message: string;
  type: "success" | "error";
}) {
  toast.custom((t) => (
    <div
      className={`z-[99999] md:max-w-[50vw] pl-3 pr-4 py-2.5 ${
        type === "success" ? "bg-[rgba(157,238,190,1)]" : "bg-red-100"
      } rounded border ${
        type === "success" ? "border-[rgba(157,238,190,1)]" : "border-red-100"
      } border-opacity-20 justify-start items-center gap-1.5 inline-flex`}
    >
      {type === "success" ? (
        <Check className="w-6 h-4 relative [&_path]:!stroke-[#11845B]" />
      ) : (
        <Cross className="w-5 h-5 relative [&>path]:stroke-red-600" />
      )}
      <div
        className={`${
          type === "success" ? "text-black" : "text-red-500"
        } text-sm font-medium leading-normal`}
      >
        {message}
      </div>
    </div>
  ));
}
